/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import { safeParse } from "../../lib/schemas.js";
import { Result as SafeParseResult } from "../../types/fp.js";
import { SDKValidationError } from "../errors/sdkvalidationerror.js";
import { AllowedOrigin, AllowedOrigin$inboundSchema } from "./allowedorigin.js";

export type UpsertAllowedOriginResult = {
  allowedOrigin: AllowedOrigin;
};

/** @internal */
export const UpsertAllowedOriginResult$inboundSchema: z.ZodMiniType<
  UpsertAllowedOriginResult,
  unknown
> = z.pipe(
  z.object({
    allowed_origin: AllowedOrigin$inboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      "allowed_origin": "allowedOrigin",
    });
  }),
);

export function upsertAllowedOriginResultFromJSON(
  jsonString: string,
): SafeParseResult<UpsertAllowedOriginResult, SDKValidationError> {
  return safeParse(
    jsonString,
    (x) => UpsertAllowedOriginResult$inboundSchema.parse(JSON.parse(x)),
    `Failed to parse 'UpsertAllowedOriginResult' from JSON`,
  );
}
